import { FC } from "react";

export const Skeleton: FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={`bg-text_primary bg-opacity-40 rounded animate-pulse ${
        className || ""
      }`}
    />
  );
};
